module.exports = __webpack_public_path__ + "static/media/6.8e0cc281.jpeg";